@if (checked) {
  <div class="cw-radio-tick" [ngStyle]="{ 'color': color }">
    <fa-icon class="icon" icon="check-circle" />
  </div>
}
